<template>
  <div class="AddBuMen">
    <div class="titleBox">
      <el-page-header v-if="isAdd" @back="goBack" :content="isAddContent">
      </el-page-header>
      <el-page-header v-else @back="goBack" :content="isEditContent">
      </el-page-header>
    </div>
    <AppBox class="appBox">
      <el-form
        v-show="isShow"
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="场景">
          <el-select
            style="width: 40%"
            v-model="formData.assistClassId"
            v-scroll="loadMore"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input
            maxlength="8"
            show-word-limit
            style="width: 40%"
            v-model="formData.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer" v-show="isShow">
        <el-button
          style="margin-right: 200px; width: 150px"
          type="primary"
          @click="handleConfirm"
          >保存查看
        </el-button>
        <el-button
          v-if="isAdd"
          style="width: 150px"
          type="primary"
          @click="handleAdd"
          >继续新增
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import { buMenMixins } from "@/pages/BuManagement/buMenMixins";
import { mapActions, mapState } from "vuex";

export default {
  name: "AddBuMen",
  components: { AppBox },
  mixins: [buMenMixins],
  data() {
    return {
      isShow: false,
      isAdd: true,
      isAddContent: "部门管理 | 新增部门",
      isEditContent: "部门管理 | 编辑部门",
      options: [
        {
          id: 0,
          name: "未分组",
        },
      ],
    };
  },
  computed: {
    ...mapState("fuzhu", ["leiBieList"]),
  },
  async mounted() {
    await this.getLeiBieList({
      page: 1,
      size: 10,
    });
    this.options = this.options.concat(this.formatData(this.leiBieList.data));
    if (this.$route.params.type === "add") {
      this.clearForm();
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
      const buMenDetail = JSON.parse(localStorage.getItem("buMenDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = buMenDetail[key];
      });
    }
    this.isShow = true;
  },
  methods: {
    ...mapActions("fuzhu", ["getLeiBieList", "saveBuMen"]),
    async loadMore() {
      const currentPage = this.leiBieList.page;
      const currentSize = this.leiBieList.size;
      const currentTotal = this.leiBieList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getLeiBieList({
          page: this.leiBieList.page + 1,
        });
        this.options = this.options.concat(this.leiBieList.data);
      }
    },
    goBack() {
      this.setData({ key: "isBack", value: true });
      this.$router.go(-1);
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        newVal[index] = {
          id: item.id,
          name: item.name,
        };
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddBuMen {
  @import "../../styles/variables";

  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }

  .appBox {
    width: 100%;
    position: relative;
    height: calc(100vh - 155px);

    .point {
      color: #c0c4cc;
      margin-left: 20px;
      cursor: default;
    }

    .footer {
      position: absolute;
      text-align: center;
      bottom: 200px;
      right: 50px;
      left: 50px;
    }
  }
}
</style>
